module.exports = require("prismjs/components/prism-clike.js");